module.exports = __webpack_public_path__ + "img/duppoi_1.8b52b923.jpg";